// src/hooks/useConfig.js
import { useSelector } from "react-redux";

export default function useConfig() {
    const configs = useSelector((state) => state.config.values);
    const loading = useSelector((state) => state.config.loading);

    const getConfig = (key) => configs[key] || null;

    return { getConfig, loading };
}
